export const IMPORT_PEOPLE = '/import/people';
export const TEMPLATE_PEOPLE = '/import/template/people';
export const IMPORT_POSITIONS = '/import/positions';
export const TEMPLATE_POSITIONS = '/import/template/positions';
